import { getScrollBarSize } from "./getScrollBarSize";
import { getScrollPosition } from "./getScrollPosition";
import { applyStyles } from "./applyStyles";
import { restorePosition } from "./restorePosition";

export const backfaceFixed = (fixed) => {
  const scrollBarWidth = getScrollBarSize();
  const scrollPosition = getScrollPosition(fixed);
  document.body.style.paddingInlineEnd = fixed ? `${scrollBarWidth}px` : "";
  applyStyles(scrollPosition, fixed);
  if (!fixed) {
    restorePosition(scrollPosition);
  }
};
